export default __webpack_public_path__ + "static/media/jack_dille.e52f1380.png";